import AuctionAuctionRecordTile from "./AuctionAuctionRecordTile";

export default AuctionAuctionRecordTile;
